import {FC} from 'react'
import {KTSVG} from '../../../../_metronic/helpers'

interface MemberProfileProps {
  firstName?: string
  surname?: string
  bioPresentation?: string
  city?: string
  aliasTitle?: string
}

export const MemberProfile: FC<MemberProfileProps> = ({
  firstName,
  surname,
  bioPresentation,
  city,
  aliasTitle,
}) => {
  return (
    <div className='member-detail__profile'>
      <div className='nb-pm-profile'>
        <div className='nb-pm-name-wrapper'>
          <div className='nb-pm-name'>{ `${aliasTitle ? aliasTitle : ''} ${firstName} ${surname}`}</div>
        </div>
        <div className='biography__divider'></div>
        <div className='nb-pm-description'>{bioPresentation}</div>

        {city && (
          <div className='nb-pm-location'>
            <KTSVG path='/media/svg/nobilis/location_mark.svg' />
            <span className='nb-pm-location-text'>{city}</span>
          </div>
        )}
      </div>
    </div>
  )
}
